import { ChangeDetectionStrategy, Component, input, InputSignal, model, ModelSignal } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { IconComponent } from '@libs/components/icons';

export type FormInputDescriptionAlignment = 'field' | 'label';

@Component({
  selector: 'ui-form-description-toggle',
  templateUrl: './form-description-toggle.component.html',
  styleUrls: ['./form-description-toggle.component.scss'],
  imports: [
    MatIconButton,
    IconComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormDescriptionToggleComponent {
  public readonly alignment: InputSignal<FormInputDescriptionAlignment> = input<FormInputDescriptionAlignment>('field');

  public readonly open: ModelSignal<boolean> = model(false);

  public toggle(): void {
    this.open.update((open: boolean) => !open);
  }
}
